<h2 mat-dialog-title>Guest User Info</h2>
<mat-dialog-content [formGroup]="data.guestForm">
    <mat-form-field class="w-100">
        <mat-label>First Name</mat-label>
        <input matInput formControlName="firstName" />
    </mat-form-field>
    <mat-form-field class="w-100">
        <mat-label>Last Name</mat-label>
        <input matInput formControlName="lastName" />
    </mat-form-field>
    <mat-form-field class="w-100">
        <mat-label>Phone Number</mat-label>
        <input (input)="onGuestKeyUpOfPhone($event)"  matInput formControlName="phoneNumber" />
    </mat-form-field>
    <mat-form-field class="w-100">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email"  readonly />
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="submit()">Verify</button>
</mat-dialog-actions>